// CRMスコアリング用のラベル定義・ペルソナ算出
// index.html のデザイン仕様に準拠

export const F2_LABELS: Record<number, string> = {
  5: '6回以上',
  4: '4～5回',
  3: '3回',
  2: '2回',
  1: '1回',
}

export const M2_LABELS: Record<number, string> = {
  5: '6回以上',
  4: '4～5回',
  3: '2～3回',
  2: '1回',
  1: '0回',
}

export const R2_LABELS: Record<number, string> = {
  1: '365日～',
  2: '91～364日',
  3: '61～90日',
  4: '31～60日',
  5: '0～30日',
}

export type Persona = {
  name: string
  rgb: string
  bgClass: string
  textClass: string
  borderClass: string
}

// F2(行動): 4〜5をHigh、1〜3をLow / M2(CV): 3〜5をHigh、1〜2をLow
export const getSegmentZone = (f2: number, m2: number): Persona => {
  if (f2 >= 4 && m2 >= 3) {
    return {
      name: 'トップエバンジェリスト',
      rgb: '251, 191, 36',
      bgClass: '#FEF3C7',
      textClass: '#92400E',
      borderClass: '#FDE68A',
    }
  }
  if (f2 >= 4 && m2 <= 2) {
    return {
      name: 'メガホン・拡散型',
      rgb: '56, 189, 248',
      bgClass: '#E0F2FE',
      textClass: '#075985',
      borderClass: '#BAE6FD',
    }
  }
  if (f2 <= 3 && m2 >= 3) {
    return {
      name: 'ミドル・ポテンシャル層',
      rgb: '52, 211, 153',
      bgClass: '#D1FAE5',
      textClass: '#065F46',
      borderClass: '#A7F3D0',
    }
  }
  if (f2 <= 3 && m2 <= 2) {
    return {
      name: 'ライト・お試し層',
      rgb: '156, 163, 175',
      bgClass: '#F3F4F6',
      textClass: '#1F2937',
      borderClass: '#E5E7EB',
    }
  }
  return {
    name: 'その他',
    rgb: '200, 200, 200',
    bgClass: '#F3F4F6',
    textClass: '#1F2937',
    borderClass: '#E5E7EB',
  }
}

export const PERSONAS: Array<{ name: string; rgb: string; description: string }> = [
  { name: 'トップエバンジェリスト', rgb: '251, 191, 36', description: '高行動・高CV' },
  { name: 'ミドル・ポテンシャル層', rgb: '52, 211, 153', description: '低行動・高CV' },
  { name: 'メガホン・拡散型', rgb: '56, 189, 248', description: '高行動・低CV' },
  { name: 'ライト・お試し層', rgb: '156, 163, 175', description: '低行動・低CV' },
]
